import {RouteDefinition} from '../../../routes';
import {SystemInfoScreen} from './SystemInfoScreen';

export const SystemInfoSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/system-info',
        component: SystemInfoScreen,
    },
];
